// removed by extract-text-webpack-plugin
module.exports = {"container":"_3qPFtsr0O81f3jZr0hVHax","content":"_3SVDADKzBoU-dyG6-F-oaZ","removed":"_1WruJyVDFBPN5GYrLBbRuU"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Bundle/style.scss
// module id = 1243
// module chunks = 0